import { HttpClient, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConnectorsService } from '~modules/connectors/services/global-connectors.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ArtifactFilesService {

    constructor(
        private readonly http: HttpClient
    ) {}

    public static getPath() {
        return `artifact-files`;
    }
    getGlobalArtifactBlobById(folderId: string, connectorId: string, runId: string, id: string): Observable<HttpEvent<Blob>> {
        const url = `${GlobalConnectorsService.getPath(folderId)}/${connectorId}/runs/${runId}/${ArtifactFilesService.getPath()}/${id}`;
        return this.http.get(url, {reportProgress: true, responseType: 'blob', observe: 'events'});
    }

    getInputArtifactBlobById(id: string): Observable<HttpEvent<Blob>> {
    const url = `${environment.apiURL}/${ArtifactFilesService.getPath()}/${id}`;
    return this.http.get(url, {reportProgress: true, responseType: 'blob', observe: 'events'});
    }
}